import { PacksClient } from '../types'

export const deleteAsset = (base: PacksClient) => (packId: string, assetId: string) =>
  base.requester.delete<any>(`/${packId}/assets/${assetId}`, { withCredentials: true })
